module.exports = __webpack_public_path__ + "static/img/合约交易_图1.aac18c72.png";